import { render, staticRenderFns } from "./AnalyticsPieChart.vue?vue&type=template&id=048d5a12&scoped=true&"
import script from "./AnalyticsPieChart.vue?vue&type=script&lang=ts&"
export * from "./AnalyticsPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyticsPieChart.vue?vue&type=style&index=0&id=048d5a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d5a12",
  null
  
)

export default component.exports